import { useState } from "react"
import { MultiSelect } from "./forms"
import { Dictionary, Installer, StatusData } from "@oneethos/shared"

type AssigneesProps = {
  project: StatusData
  installersMap: Dictionary<Installer>
  onChange: (p: StatusData) => void
  onDoneEditing?: () => void
}

type AssigneeBadgeProps = {
  installer?: Installer
}

const AssigneeBadge = ({ installer }: AssigneeBadgeProps) => {
  if (!installer) {
    return <span className="badge rounded-pill border fw-normal bg-light text-muted">
      Unknown assignee
    </span>
  }

  const inactive = installer.active === false
  const variant = inactive
    ? 'bg-secondary-subtle text-secondary-emphasis text-decoration-line-through'
    : 'bg-primary-subtle text-primary-emphasis'

  return <span
    className={`badge rounded-pill border fw-normal ${variant}`}
    title={inactive ? 'inactive' : undefined}
  >
    {installer.email}
  </span>
}

export const Assignees = ({
  project,
  onDoneEditing,
  onChange,
  installersMap
}: AssigneesProps) => {
  const [editingAssignees, setEditingAssignees] = useState(false)

  const authorizedOptions = {}
  Object.entries(installersMap).forEach(([id, installer]) => authorizedOptions[id] = installer.email)

  return <div className="assignees mt-3">
    <div><b>Solar Representative</b></div>
    {editingAssignees ? (
      <>
        <div style={{ margin: '1em 0' }}>
          <MultiSelect
            options={authorizedOptions}
            values={project.authorizedInstallers || []}
            onChange={vals => onChange(new StatusData({
              ...project,
              authorizedInstallers: vals
            }))}
            wrapStyle={{ maxHeight: '26em', overflowY: 'auto' }}
          />
        </div>
        <div>
          <button
            onClick={() => {
              setEditingAssignees(false)
              onDoneEditing()
            }}
            className="btn btn-dark"
            type="button">Done</button>
        </div>
      </>
    ) : <div className="ass-list my-1 d-flex flex-wrap align-items-center gap-2">
      {(project.authorizedInstallers || []).map(id =>
        <AssigneeBadge key={id} installer={installersMap[id]} />)}
      {!project.authorizedInstallers?.length ? <span className="text-muted">(Unassigned)</span> : null}
      <span className="link-primary" onClick={() => setEditingAssignees(true)}>edit</span>
    </div>}
  </div>
}